import { render, staticRenderFns } from "./register_org.vue?vue&type=template&id=c6744010&scoped=true"
import script from "./register_org.vue?vue&type=script&lang=js"
export * from "./register_org.vue?vue&type=script&lang=js"
import style0 from "./register_org.vue?vue&type=style&index=0&id=c6744010&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6744010",
  null
  
)

export default component.exports